import React from 'react'

import classNames from 'classnames'

import { APIError, useAPIError } from '@providers/APIErrorProvider'
import i18n from '@utils/i18n'

import ErrorToast from './shared/ErrorToast'

interface Props {
  headerVisible: boolean
}

const APIErrorToast: React.FC<Props> = ({ headerVisible }: Props) => {
  const { errors, clearError } = useAPIError()

  if (!errors.length) return null
  return (
    <div
      className={classNames(
        'flex fixed right-0 left-0 z-50 flex-col items-center',
        headerVisible ? 'top-[65px]' : 'top-0'
      )}>
      {errors.map((error, index) => (
        <ErrorToast
          error={getErrorMessage(error)}
          key={`${error.code}${error.timestamp}`}
          onClearError={() => clearError(index)}
        />
      ))}
    </div>
  )
}

export default APIErrorToast

function getErrorMessage(err: APIError): string {
  let message = ''
  if (err.code) message = i18n.t(`errors.${err.code}`, err.message)
  else if (err.message) message = err.message

  if (!message) message = i18n.t('errors.unexpectedError')
  return message
}
